/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Tab_PersonalInputs */



/**
* | output |
* | --- |
* | "For my conversations" |
*
* @param {Practice_Tab_PersonalInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_tab_personal = /** @type {((inputs?: Practice_Tab_PersonalInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Tab_PersonalInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor mijn gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour mes entretiens")
	return /** @type {LocalizedString} */ ("For my conversations")
});